import type { PropsWithChildren } from 'react'

export const AlertMain = ({ children }: PropsWithChildren) => (
  <div className="flex-1 flex flex-col">{children}</div>
)
